<template>
   <section class="Search__condition__list0011">
      <el-row :gutter="0" class="Search__condition__listHead">
         <router-link to="/sp/0002" class="Router__To__Destination" tabindex="1"> 
            <i class="el-icon-close" tabindex="1"></i> 
         </router-link>
         <el-col :span="6" class="whiteBg"> 
            <span class="Search__condition__listSpan">検索条件一覧</span> 
         </el-col>
         <el-col :span="12"> 
            <img src="../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
         </el-col>
         <el-col :span="6"></el-col>
      </el-row>
      <el-row class="Search__condition__listBody">
         <div class="search__condition__btn__group">
            <!-- <router-link to="/sp/0012" class="Router__To__Destination" tabindex="1"> -->
               <el-button type="primary"  plain @click="add()">追加</el-button>
            <!-- </router-link> -->
            <el-button type="danger" plain @click="removeFromTable()">削除</el-button>
            <router-link to="/sp/0002" class="Router__To__Destination" tabindex="1">
               <el-button type="info" plain>戻る</el-button>
            </router-link>
         </div>
         <div class="search__condition__table">
            <template>
               <el-table 
                  v-loading="loading"
                  border 
                  ref="multipleTable" 
                  :data="getSearchConditionTitle" 
                  style="width: 100%" 
                  @selection-change="handleSelectionChange" 
                  >
                  <el-table-column type="selection"></el-table-column>
                  <el-table-column property="title" label="検索条件タイトル"></el-table-column>
                  <el-table-column label="編集">
                     <template slot-scope="scope">
                      
                         <el-button type="primary"  @click="gotoedit(scope.row)">編集</el-button>
                     </template>
                  </el-table-column>
               </el-table>
            </template>
         </div>
         <div class="search__condition__btn__group">
            <!-- <router-link to="/sp/0012" class="Router__To__Destination" tabindex="1"> -->
               <el-button type="primary"  plain @click="add()">追加</el-button>
            <!-- </router-link> -->
            <el-button type="danger" plain @click="removeFromTable()">削除</el-button>
            <router-link to="/sp/0002" class="Router__To__Destination" tabindex="1">
               <el-button type="info" plain >戻る</el-button>
            </router-link>
         </div>
      </el-row>
   </section>
</template>
<script> 
   import { mapGetters } from "vuex"; 
   
   import json from '../../components/config.json'; 
   //import Common from '../../common/CommonFunc.js';
   import router from "../../router";
   import jsonConst from '../../common/CommonConst.json';
   export default { 
   
   name: "Search__condition__list0011", 
   
   props: [], 
   
   
   
   data() { 
   
   return { 
   loading:false,
   multipleSelection: [] ,
   deletetableload:''
   
   }; 
   
   }, 
   
   methods: { 
   
   handleSelectionChange(val) { 
   
   this.multipleSelection = val; 
   
   }, 
   
   removeFromTable() { 
      this.$LogButtonEvent("0011","Delete");
      this.$LogMethodIN("0011","removeFromTable");
   
   if(this.$refs.multipleTable.selection.length > 0){
                this.$confirm(json["0011_delete_confirm_message"], json["0011_delete_confirm_message_title"], {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'キャンセル',
                    
                }).then(() => {
                    var selectedArray = this.$refs.multipleTable.selection.length;
                     var arrayForDelete = {};
                    var SearchConditionTitle=[];  
                    for(var i=0;i<selectedArray;i++){ 
                       var assignArray={};
                    assignArray.title=this.$refs.multipleTable.selection[i].title ;
                    SearchConditionTitle.push(assignArray);
                    console.log(SearchConditionTitle)
                       // SearchConditionTitle.push(this.$refs.multipleTable.selection[i].title);
                       // console.log(this.$refs.multipleTable.selection[i].title);
                    }
                     arrayForDelete = {
                       // contract_id : this.getContractId,
                        title_info:SearchConditionTitle,
                        user_id:this.getUserId                 
                     }      
                        console.log(arrayForDelete) ;        
                        this.$store.dispatch('sp_Communication0011/deleteSelected',arrayForDelete).then(() => {
                         var status = this.getDeleteTable
                           if(status == 0){
                              this.$alert(this.getmessageDetail, json["0011_delete_success_title"], {
                                 confirmButtonText: 'OK',
                              }).then(()=>{
                                    this.loading=true;
                                 this.$store.dispatch('sp_Communication0011/showTable0011', this.deletetableload).then(()=>
                                    {
                                       this.loading=false;
                                    })
                                    .catch(() => {
                                       this.loading = false;
                                    })
                              });
                           } else {
                                 this.$alert(this.getmessageDetail, "確認", {
                                    confirmButtonText: 'OK'
                                 });   
                              }
                        }) 
                })
            }else{
                this.$alert(json["0011_checkbox_not_check_message"], json["0011_checkbox_not_check_message_title"], {
                    confirmButtonText: 'OK'
                });                 
             } 
      this.$LogMethodOut("0011","removeFromTable");
   } ,
    gotoedit(row)
        {
           this.$LogButtonEvent("0011","Edit");
           this.$LogMethodIN("0011","gotoedit");
            // router.push({name : "0012"});
            var titleRow = {
			contract_id: jsonConst['contract_id'],
			user_id: jsonConst['user_id'],
			title: row.title

        };
        var editToken = {
            flag:1
        }
		console.log(titleRow)
        this.$store.dispatch('sp_Communication0011/titleEdit', titleRow).then(() => {
        router.push({
            name: "sp_0012",
            params: {
            editToken: editToken
          }
		});
      
    });
    this.$LogMethodOut("0011","gotoedit");
        },

        add(){
         this.$LogButtonEvent("0011","Add");
         this.$LogMethodIN("0011","add"); 
         this.$store.commit('sp_Situation0012/setMediaNameList',[])   
         router.push({name : "sp_0012"});
         this.$LogMethodOut("0011","add");
        },
   
   }, 
   mounted() {
        var tableDetails0011 = {
           //contract_id: this.getContractId, 
           user_id: this.getUserId
           };
           this.deletetableload = tableDetails0011;
         console.log(tableDetails0011)
         this.loading=true;
         this.$store.dispatch('sp_Communication0011/showTable0011',tableDetails0011).then(()=>
										{
											this.loading=false;
										})
										.catch(() => {
											this.loading = false;
                              })
         this.$store.commit('sp_Situation0001/setThemeLoadCheck', 0);
         
    },
   computed: { 
   
   ...mapGetters("sp_Situation0011", ["getSearchConditionTitle","getDeleteTable","getmessageDetail"]),
   ...mapGetters("situation0001", [
      "getUserId",
      "getContractId",
      
   ])  
   
   },

   beforeCreate(){
      //Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
     //Common.Session.CheckIsMobile("/sp/0011","/0011"); // MobileScreen Path, WebScreen Path
   }
   
   }; 
   
</script> 
<style scoped> 
   @import "0011.css"; 
   @import "../../assets/css/customStyle.css";  
</style>